import Vue from 'vue'
import moment from 'moment'
import pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'

const state = {
  audit: [],
  audits: [],
  // Note: Had to declare this outside audit since it might need a lot of changes if it was included inside audit
  auditDetails: {
    id: null,
    key: null,
    auditor: null,
    location: null,
    building: null
  },
  downloadingPDF: false,
  buildingNoteComment: null
}

const mutations = {
  SET_AUDIT({
    commit
  }, value) {
    state.audit = value
  },
  DELETE_AUDIT({
    commit
  }, audit) {
    state.audits.splice(state.audits.indexOf(audit), 1)
  },
  SET_AUDITS_TO_USER(state, audits) {
    state.audits = audits || []
  },
  SET_ANSWER(state, {
    questionID,
    answer
  }) {
    for (let x of state.audit) {
      if (x.Question.ID === questionID) {
        x.Answer = answer
        break
      }
    }
  },
  SET_COMMENTS(state, {
    sectionID,
    comments
  }) {
    state.audit.forEach((x, i) => {
      if (x.Section.ID === sectionID) {
        x.Comments = comments
      }
    })
  },
  UPDATE_UPLOAD_PROGRESS(state, {
    sectionID,
    percentCompleted
  }) {
    state.audit.filter(item => {
      if (item.Section.ID === sectionID) {
        item.UploadProgress = percentCompleted
      }
    })
  },
  SET_AUDIT_DETAILS(state, auditDetails) {
    state.auditDetails = auditDetails
  },
  SET_BUILDING_NOTE(state, buildingNotes) {
    state.buildingNoteComment = buildingNotes
  }
}

const actions = {
  getAll({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/getall`)
        .then(response => {
          // commit('SET_AUDITS_TO_USER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateBuildingNote({
    commit
  }, {surveyId, comment, isDefault}) {
    state.auditDetails.buildingNotes = comment
    console.log(state)
    console.log(state.auditDetails)
    console.log(state.auditDetails.buildingNotes)
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}audit/updatebuildingnote?surveyId=${surveyId}&comment=${comment}&isDefault=${isDefault}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBuildingNotes({
    commit
  }, surveyId) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/GetBuildingNotes?surveyId=${surveyId}`)
        .then(response => {
          if (response.data !== '') {
            commit('SET_BUILDING_NOTE', response.data.buildingNoteComment)
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAudit({
    commit
  }, value) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/get?id=${value}`)
        .then(response => {
          if (response.data !== '') {
            commit('SET_AUDIT', response.data.audit)
            commit('SET_AUDIT_DETAILS', response.data.auditDetails)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAuditByKey({
    commit
  }, {
    key,
    userID
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/getbykey?key=${key}&userID=${userID}`)
        .then(response => {
          if (response.data !== '') {
            commit('SET_AUDIT', response.data.audit)
            commit('SET_AUDIT_DETAILS', response.data.auditDetails)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAuditsAssignedToUser({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/GetAssignedToUser`)
        .then(response => {
          commit('SET_AUDITS_TO_USER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAuditsByLocation({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/getbylocation`)
        .then(response => {
          commit('SET_AUDITS_TO_USER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  assignAudit({
    commit
  }, {
    templateID,
    buildingID,
    userID
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}audit/create`, {
        TemplateID: templateID,
        BuildingID: buildingID,
        AssignedTo: userID
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteAudit({
    commit
  }, audit) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}audit/delete`, {
        ID: audit.ID
      })
        .then(response => {
          if (response) {
            commit('DELETE_AUDIT', audit)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateAnswer({
    commit
  }, {
    auditID,
    questionID,
    answer
  }) {
    return new Promise((resolve, reject) => {
      // set answer on audit state
      commit('SET_ANSWER', {
        questionID,
        answer
      })

      // create an object with the required format: Example: [{"QuestionID": 1, "AnswerID": 4, Photos: []}, {"QuestionID": 2, "AnswerID": 3, Photos: []}]
      let answers = state.audit
      answers = answers.filter(item => item.Answer.ID !== null)
        .map(x => {
          return {
            QuestionID: x.Question.ID,
            AnswerID: x.Answer.ID,
            Photos: []
          }
        })

      // update on database
      Vue.axios.post(`${window.config.apiUrl}audit/update`, {
        ID: auditID,
        Answers: JSON.stringify(answers)
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateComments({
    commit
  }, {
    auditID,
    sectionID,
    comments
  }) {
    return new Promise((resolve, reject) => {
      // set answer on audit state
      commit('SET_COMMENTS', {
        sectionID,
        comments
      })

      // create an object with the required format: Example: [{"SectionID": 1, "Comments": "Testing"}]
      let cmts = state.audit
      let sections = []

      cmts = cmts.filter(item => item.Section.Comments !== null) // Get only sections with comments
        .map(x => {
          // Remove duplicates (since we are looping per questions and not per sections)
          if (sections.indexOf(x.Section.ID) === -1) {
            sections.push(x.Section.ID)
            return {
              SectionID: x.Section.ID,
              Comments: x.Comments
            }
          }
        })
        .filter(item => item !== undefined) // Remove undefined (The previous map function still inserts an undefined object if the SectionID is already in the sections list)

      // update on database
      Vue.axios.post(`${window.config.apiUrl}audit/updateComments`, {
        ID: auditID,
        Comments: JSON.stringify(cmts)
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  resetAuditSelection({
    commit
  }) {
    commit('SET_AUDIT', [])
  },
  uploadPhoto({
    commit
  }, {
    photos,
    sectionID
  }) {
    return new Promise((resolve, reject) => {
      let config = {
        onUploadProgress: function (progressEvent) {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          commit('UPDATE_UPLOAD_PROGRESS', {
            sectionID,
            percentCompleted
          })
        }
      }

      Vue.axios.post(`${window.config.apiUrl}audit/uploadphoto`, photos, config)
        .then(response => {
          state.audit.filter(x => {
            if (x.Section.ID === sectionID) {
              if (x.Section.Photos !== null && x.Section.Photos !== '') {
                x.Section.Photos += ',' + response.data
              } else {
                x.Section.Photos = response.data
              }
            }
          })
          resolve(response)
        })
        .catch(err => {
          reject(err.message)
        })
    })
  },
  deletePhoto({
    commit
  }, {
    filename,
    auditID,
    sectionID
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}audit/deletephoto?filename=${filename}&auditID=${auditID}&sectionID=${sectionID}`)
        .then(response => {
          // If response wasn't valir, return
          if (!response) return

          // Remove photo from audit state
          state.audit.filter(x => {
            if (x.Section.ID === sectionID) {
              x.Section.Photos = x.Section.Photos.replace(`${filename}`, '').replace(',,', ',')

              if (x.Section.Photos.charAt(0) === ',') {
                x.Section.Photos = x.Section.Photos.substring(1)
              } else if (x.Section.Photos.charAt(x.Section.Photos.length - 1) === ',') {
                x.Section.Photos = x.Section.Photos.substring(0, x.Section.Photos.length - 1)
              }
            }
          })
          resolve(response)
        })
        .catch(err => {
          reject(err.message)
        })
    })
  },
  resetUploadProgress({
    commit
  }, sectionID) {
    commit('UPDATE_UPLOAD_PROGRESS', {
      sectionID,
      percentCompleted: 0
    })
  },
  getReport({
    commit
  }, {
    start,
    end
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}report/get?start=${start}&end=${end}`)
        .then(response => {
          if (response.data === '') {
            reject(new Error('No data found.'))
            alert('No data found.')
          } else {
            resolve(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReportByLocation({
    commit
  }, {
    locationID,
    start,
    end
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}report/getByLocation?locationID=${locationID}&start=${start}&end=${end}`)
        .then(response => {
          if (response.data === '') {
            reject(new Error('No data found.'))
          } else {
            resolve(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReportByBuilding({
    commit
  }, {
    buildingID,
    start,
    end
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}report/getByBuilding?buildingID=${buildingID}&start=${start}&end=${end}`)
        .then(response => {
          if (response.data === '') {
            reject(new Error('No data found.'))
          } else {
            resolve(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReportByUser({
    commit
  }, {
    userID,
    start,
    end
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}report/getByUser?userID=${userID}&start=${start}&end=${end}`)
        .then(response => {
          if (response.data === '') {
            reject(new Error('No data found.'))
          } else {
            resolve(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadPDF({
    commit,
    rootState
  }) {
    state.downloadingPDF = true
    pdfMake.vfs = pdfFonts.pdfMake.vfs
    // Content
    var content = []
    // Logo
    content.push({
      image: rootState.global.logo,
      width: 150,
      margin: [0, 0, 0, 25]
    })

    // Get audit score
    var score = 0
    rootState.audits.audit.forEach(x => {
      score += x.Answer.Value
    })
    score = ((score / rootState.audits.auditDetails.maxScore) * 100).toFixed(0).replace('.00', '') + '%'

    // Top details
    content.push({
      style: 'tableExample',
      table: {
        headerRows: 1,
        widths: [125, 150, '*', '*', '*'],
        body: [
          [{
            text: `Location`,
            fontSize: 10,
            bold: true
          },
          {
            text: `Building`,
            fontSize: 10,
            bold: true
          },
          {
            text: `Auditor`,
            fontSize: 10,
            bold: true,
            alignment: 'right'
          },
          {
            text: `Score`,
            fontSize: 10,
            bold: true,
            alignment: 'right'
          },
          {
            text: `Created On`,
            fontSize: 10,
            bold: true,
            alignment: 'right'
          }
          ],
          [{
            text: state.auditDetails.location,
            fontSize: 12,
            bold: false
          },
          {
            text: state.auditDetails.building,
            fontSize: 12,
            bold: false
          },
          {
            text: state.auditDetails.auditor,
            fontSize: 12,
            bold: false,
            alignment: 'right'
          },
          {
            text: score,
            fontSize: 12,
            bold: false,
            alignment: 'right'
          },
          {
            text: moment(state.auditDetails.createdOn).format('MM/DD/YYYY'),
            fontSize: 10,
            bold: false,
            alignment: 'right'
          }
          ]
        ]
      },
      layout: 'noBorders'
    })
    // Divider
    content.push({
      text: '__________________________________________________________________________________________________________________',
      color: '#ccc',
      fontSize: 10,
      margin: [0, 0, 0, 5]
    })
    var buildingNotes = state.auditDetails.buildingNotes
    if (buildingNotes) {
      content.push({
        text: 'Building Notes',
        fontSize: 14,
        bold: true,
        margin: [0, 15, 0, 5]
      }, {
        text: state.auditDetails.buildingNotes,
        fontSize: 12,
        bold: false,
        alignment: 'left'
      })
    }
    // Get unique sections
    var sections = [...new Set(state.audit.map(x => x.Section.ID))]
    // Get all filenames separately
    var photos = []
    sections.forEach(sectionID => {
      var filenames = state.audit.filter(y => y.Section.ID === sectionID)[0].Section.Photos
      if (filenames) {
        filenames.split(',').forEach(filename => {
          photos.push({
            sectionID,
            filename
          })
        })
      }
    })
    // Prepare a promises array to get photos first
    var promises = []
    if (photos) {
      photos.forEach(item => {
        // Fill promises array
        promises.push(
          new Promise((resolve, reject) => {
            Vue.axios.get(`/uploads/${state.auditDetails.id}/${item.sectionID}/resized_${item.filename}`, {
              responseType: 'arraybuffer'
            })
              .then((response) => {
                let image = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
                resolve({
                  sectionID: item.sectionID,
                  dataURL: `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
                })
              })
          })
        )
      })
    }
    Promise.all(promises).then(dataURLs => {
      // Loop thru sections to create tables
      sections.forEach(sectionID => {
        // Section Title
        var title = state.audit.filter(y => y.Section.ID === sectionID)[0].Section.Text
        content.push({
          text: title,
          fontSize: 15,
          bold: true,
          margin: [0, 15, 0, 5]
        })
        // Table
        var body = []
        // Add Headers
        body.push([{
          text: 'Item',
          fontSize: 14,
          bold: true
        }, {
          text: 'Answer',
          fontSize: 14,
          bold: true
        }])
        // Add Rows
        state.audit.filter(y => y.Section.ID === sectionID).forEach(x => body.push([x.Question.Text, x.Answer.Text]))
        // Add Table to Content
        content.push({
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ['*', 75],
            body
          }
        })
        // Comments
        var comments = state.audit.filter(y => y.Section.ID === sectionID)[0].Section.Comments
        if (comments) {
          content.push({
            text: 'Comments',
            fontSize: 14,
            bold: true,
            margin: [0, 15, 0, 5]
          }, {
            text: comments,
            fontSize: 12
          })
        }
        // Images
        var images = dataURLs.filter(x => x.sectionID === sectionID)
        if (images) {
          var columns = []
          var margin = [0, 10, 0, 0]
          var columnGap = 10
          images.forEach((image, i) => {
            // Add photo into columns array
            columns.push({
              image: image.dataURL,
              width: 252.5
            })
            // Whenever we got 2 columns(photos), we add them into the content
            if (columns.length === 2) {
              content.push({
                columns,
                margin,
                columnGap
              })
              columns = []
              // If it's the last image, add the single column
            } else if (images.length === i + 1) {
              content.push({
                columns,
                margin,
                columnGap
              })
            }
          })
        }
      })
      // Styles
      var styles = {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        }
      }
      // Create and Download PDF
      var docDefinition = {
        content,
        styles
      }
      pdfMake.createPdf(docDefinition).download(`${state.auditDetails.building} - ${state.auditDetails.location} - ${state.auditDetails.auditor}.pdf`)
      state.downloadingPDF = false
    })
  },
  sendReport({
    commit
  }, email) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}audit/sendreport?auditKey=${state.auditDetails.key}&email=${email}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  notifyAdminsAuditIsComplete({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}audit/sendcompletionemail?auditID=${state.auditDetails.id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getters = {
  sections() {
    // Resource: https://goo.gl/gUuY5P (Remove duplicates from an array of objects in javascript)
    if (state.audit === '') return
    return state.audit.filter((thing, index, self) => self.findIndex((t) => {
      return t.Section.ID === thing.Section.ID && t.Section.Text === thing.Section.Text
    }) === index)
  },
  audit() {
    return state.audit
  },
  auditDetails() {
    return state.auditDetails
  },
  userAudits() {
    return state.audits
  },
  auditScore() {
    let score = 0

    // Sum all points
    state.audit.forEach(x => {
      if (x.Answer.Value !== null) {
        score += x.Answer.Value
      }
    })

    // Calculate score based on questions
    score = (score / (state.audit.length * 4) * 100).toFixed(0).replace('.00', '') // "4" = max score per question

    return score
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/audits.js